import axios from 'axios';

export default {
    search: function () {
      return axios.get('/api/manual/items')
    },
    find: function(id) {
      return axios.get(`/api/manual/${id}`)
    },
    save: function(data) {
      if (data.id && data.id > 0)
        return axios.put('/api/manual/', data);
      else
        return axios.post('/api/manual/', data);
    },
    create: function (data) {      
      return axios.post('/api/manual/', data)
    },
    update: function (data) {      
      return axios.put('/api/manual/', data)
    },
    delete: function(id) {
      return axios.delete(`/api/manual/${id}`)
    }
  }